import React from 'react';
import styled from 'styled-components';
import { ButtonUrl, Container, Section, Text14, Text16, Wrapper } from '../../atoms';
import { Intro } from '../../molecules';

const normalizeLink = (link) => {
  if (!link || typeof link !== 'string') return '';
  return link.replace(/^\/(https?:\/\/)/, '$1');
}

const getButtonData = (button) => {
  if (!button) return null;

  if (typeof button === 'string') {
    return {
      label: 'Saber mais',
      link: normalizeLink(button),
    };
  }

  const link = normalizeLink(button.link || button.url || button.href || button.slug);
  const label = button.text || button.label || button.title || 'Saber mais';

  if (!link) return null;

  return {
    label,
    link,
  };
}

const normalizeColor = (color) => {
  if (!color || typeof color !== 'string') return undefined;
  return color.replace(/^#/, '');
}

export default function ProductComparation({ title, description, products }) {
  if ((!title && !description) && (!products || products.length === 0)) {
    return null;
  }

  return (
    <Section backgroundColor="#fff" className='about'>
      <Wrapper both noHeight>
        <Container md>
          <Content>
            {(title || description) &&
              <Header>
                <Intro
                  titleSize="H3"
                  title={title}
                  titleColor="#35383B"
                  titleTextAlign="center"
                  titleMaxWidth="640px"
                  description={description}
                  descriptionSize={18}
                  descriptionColor="#5D6368"
                  descriptionTextAlign="center"
                  descriptionMaxWidth="760px"
                />
              </Header>
            }
            {(products && products.length > 0) &&
              <Cards>
                {products.map((product, index) => {
                  const buttonData = getButtonData(product?.button);

                  return (
                  <Card key={String(index)}>
                    {product?.image?.url &&
                      <Logo src={product.image.url} alt={product?.image?.title || product?.title || `product-${index}`} />
                    }
                    {product?.description &&
                      <CardDescription color="#5D6368" dangerouslySetInnerHTML={{ __html: product.description }} />
                    }
                    {(product?.items && product.items.length > 0) &&
                      <Items>
                        {product.items.map((item, itemIndex) => (
                          <Item key={String(itemIndex)}>
                            <ItemIcon src="/static/images/check.svg" alt="" />
                            <ItemText color="#5D6368" dangerouslySetInnerHTML={{ __html: item?.text || '' }} />
                          </Item>
                        ))}
                      </Items>
                    }
                    {buttonData &&
                      <ButtonWrap>
                        <ButtonUrl
                          text={buttonData.label}
                          link={buttonData.link}
                          color={normalizeColor(product?.buttonColor)}
                        />
                      </ButtonWrap>
                    }
                  </Card>
                )})}
              </Cards>
            }
          </Content>
        </Container>
      </Wrapper>
    </Section>
  );
}

const Content = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
`;

const Header = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  width: 100%;
`;

const Cards = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
  margin-top: 48px;
  @media screen and (max-width: 900px){
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  background: #FFFFFF;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  padding: 32px;
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  @media screen and (max-width: 760px){
    padding: 24px;
  }
`;

const Logo = styled.img`
  max-width: 40%;
  width: auto;
  height: auto;
  object-fit: contain;
  object-position: left center;
`;

const CardDescription = styled(Text14)`
  margin-top: 20px;
  font-size: 16px;
  line-height: 22px;
  p{
    margin: 0;
  }
`;

const Items = styled.div`
  display: flex;
  flex-flow: column;
  margin-top: 20px;
  width: 100%;
  gap: 10px;
`;

const Item = styled.div`
  display: flex;
  align-items: center;
`;

const ItemIcon = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
  margin-right: 10px;
  flex-shrink: 0;
`;

const ItemText = styled(Text16)`
  line-height: 22px;
  p{
    margin: 0;
  }
`;

const ButtonWrap = styled.div`
  margin-top: 24px;
`;
